<template>

    <!-- Go to www.addthis.com/dashboard to customize your tools -->
    <div
        v-if="!loading"
        id="addthis-share"
        :class="'addthis_toolbox addthis_inline_share_toolbox_' + settings.inline_tool_id"
        :data-title="settings.title"
        :data-url="settings.url"
    ></div>

</template>

<script>

    import axios from 'axios';

    export default {
        name: 'AddThisShare',
        props: {
            cdn: {
                type: String,
                default: '//s7.addthis.com/js/300/addthis_widget.js'
            },
        },
        data(){
            return {
                loading: true,
                settings: null
            }
        },
        methods: {
          init(){
              return axios.get('/api/addthis/settings').then((response)=>{
                  this.loading = false;
                  this.settings = response.data;
                  if (this.settings.public_id) {
                      this.loadAddThis();
                  }
              });
          },
          loadAddThis(){
              if (process.browser) {
                  if (document.getElementById('addthis-share') !== null) {
                      return window.addthis && window.addthis.layers && window.addthis.layers.refresh();
                  }

                  const el = document.createElement('script');
                  el.setAttribute('id', 'addthis-share')
                  el.setAttribute('src', `${this.cdn}#pubid=${this.settings.public_id}`)
                  document.body.appendChild(el);

              }
          }
        },
        mounted() {
            this.init();
        }
    }

</script>
